import React, { useState,useEffect } from 'react';
import FormInput from './FormInput';
import FormSelector from './FormSelector';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { PostApi } from '../../middleware/postMiddleware';
import ReCAPTCHA from 'react-google-recaptcha';
import { isTokenValid,getPayload } from '../../helpers/jwt';
import axios from 'axios';
import querystring from 'querystring';
import { TextField, Button, IconButton } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useLocation } from 'react-router-dom/cjs/react-router-dom';


function OrderForm({ title, heading, url }) {
    const history = useHistory();
    const [verified, setVerified] = useState(false);
    const [cityId, setCity] = useState('');
    const [message, setMessage] = useState("");
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemCount, setItemCount] = useState(3);

    const increaseItemCount = (e) => {
        e.preventDefault();
        if(itemCount >= 5 )
            return toast.error('Maximum 5 items can be added.');

        setItemCount(prev => ++prev);
    }

    const location = useLocation();
    const [productName, setProductName] = useState('');

    useEffect(() => {
        // Only auto-fill if coming from a page that passed `product`
        if (location.state?.product) {
            setProductName(location.state.product);
        }
    }, [location.state]);



  const onChangeHandler = (e) => setMessage(e.target.value);

  const onFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter((file) =>
      file.size <= 5000000 && ["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    );

    if (validFiles.length !== selectedFiles.length) {
      toast.error("Some files are invalid or too large and have been excluded.");
    }

    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const removeFile = (index) => setFiles(files.filter((_, i) => i !== index));



    // ReCAPTCHA verification handler
    function onReCaptchaChange(value) {
        setVerified(!!value);
    }

    const validateForm = (event) => {
        const form = event.target;
        const requiredFields = ['FirstName', 'LastName', 'Company', 'Phone','Email','Country'];
        return requiredFields.every(field => form[field]?.value);
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        if (!validateForm(event)) {
            toast.error('Please fill in all required fields.');
            return;
        }

        setLoading(true);

        let customerId = null;
        if (isTokenValid("auth_token")) {
            customerId = getPayload("auth_token").id;
        }

        const formData = new FormData();

        // Append customer ID if available
        if (customerId) {
            formData.append("customerId", customerId);
        }

        // Append Billing Info
        formData.append("FirstName", event.target.FirstName.value);
        formData.append("LastName", event.target.LastName.value);
        formData.append("Company", event.target.Company.value);
        formData.append("Phone", event.target.Phone.value);
        formData.append("Email", event.target.Email.value);
        formData.append("Country", event.target.Country.value);
        formData.append("Industry", event.target.Industry.value);
        formData.append("ProductType", event.target.ProductType.value);
        formData.append("Reference", event.target.Reference.value);
        formData.append("shippingMethod", event.target.shippingMethod.value);
        formData.append("paymentMethod", event.target.paymentMethod.value);
        formData.append("Message", message);

        

        // Append items (assuming a fixed number of 10 items)
        for (let i = 0; i < itemCount; i++) {
            formData.append(`Items[${i}][Serial]`, i + 1);
            formData.append(`Items[${i}][ItemNumber]`, event.target[`itemNumber${i + 1}`]?.value || '');
            formData.append(`Items[${i}][Quantity]`, event.target[`quantity${i + 1}`]?.value || '');
            formData.append(`Items[${i}][Description]`, event.target[`description${i + 1}`]?.value || '');
        }

        // Append attachments
        files.forEach(file => {
            formData.append("attachments", file);
        });

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}${url}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (res.status === 200 && res.data.success) {
                toast.success('Response Sent Successfully');
                setTimeout(() => history.push('/'), 2500);
            } else {
                toast.error('Please Fill all the required data');
            }

        } catch (error) {
            console.error(error);
            toast.error('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer autoClose={3000} />
            <section className="contact-form-wrapper section-padding pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-left">
                            <h1>{heading}</h1>
                        </div>
                        <form onSubmit={onSubmitHandler} className="row contact-form">
                            {/* Billing Information */}
                            <div className='col-12 d-md-flex flex-md-wrap' style={{gap: '1rem'}}>
                                <FormInput label="* First Name" name="FirstName" />
                                <FormInput label="* Last Name" name="LastName" />
                                <FormInput label="* Company" name="Company" />
                                <FormInput label="* Phone Number" name="Phone" />
                                <FormInput label="* Email" name="Email" />
                                <FormSelector label="* Country" name="Country" setCity={setCity}/>
                                <FormInput label="Industry" name="Industry" />
                                <FormInput label="Product Type" name="ProductType" value={productName}/>
                                <FormInput label="Reference a Previous Order or Invoice(Add Order or Invoice ID)" name="Reference" />
                            </div>
                            <div className="file-input-wrapper">
                                <label htmlFor="file-upload" className="theme-btn" style={{textTransform: "none"}}>Upload File(s)</label>
                                <input id="file-upload" type="file" onChange={onFileChange} multiple className="file-input" />
                            </div>
            
                            <div className="selected-files">
                                {files.map((file, index) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                    <span>{file.name}</span>
                                    <IconButton onClick={() => removeFile(index)} size="small" aria-label="remove" style={{ marginLeft: "5px" }}>
                                        <CloseIcon />
                                    </IconButton>
                                    </div>
                                ))}
                            </div>

                            {/* Item Form Table */}
                            <div className="col-12 mt-4">
                                <h2>Item Form</h2>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '10%' }}>Sr#</th>
                                                <th style={{ width: '30%' }}>Item Number</th>
                                                <th style={{ width: '30%' }}>Quantity</th>
                                                <th style={{ width: '30%' }}>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody id='items_container'>
                                            {Array.from({ length: itemCount }, (_, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>
                                                        <input type="text" name={`itemNumber${i + 1}`} className="form-control" />
                                                    </td>
                                                    <td>
                                                        <input type="text" name={`quantity${i + 1}`} className="form-control" />
                                                    </td>
                                                    <td>
                                                        <input type="text" name={`description${i + 1}`} className="form-control" />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <button className="theme-btn" onClick={increaseItemCount}>Add Item Row</button>
                                </div>
                            </div>

                            {/* Shipping Method Dropdown */}
                            <div className="col-12 col-md-6 mt-3">
                                <h3>Choose Shipping Method:</h3>
                                <select name="shippingMethod" className="form-select">
                                    <option value="">Please select</option>
                                    <option value="UPS">UPS</option>
                                    <option value="Fedex">Fedex</option>
                                    <option value="DHL">DHL</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            {/* Payment Method Dropdown */}
                            <div className="col-12 col-md-6 mt-3">
                                <h3>Choose Payment Method:</h3>
                                <select name="paymentMethod" className="form-select">
                                    <option value="">Please select</option>
                                    <option value="Credit Card">Credit Card</option>
                                    <option value="COD">COD</option>
                                    <option value="Purchase Order">Purchase Order</option>
                                </select>
                            </div>
                            <div className='mt-5'>
                                <TextField
                                    // label= "* Comments"
                                    placeholder="Write here any additional information you want to describe to us."
                                    multiline
                                    rows={2}
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={message}
                                    onChange={onChangeHandler}
                                />
                            </div>

                            {/* ReCAPTCHA */}
                            <div className="col-12 my-4 text-center">
                                <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_KEY} onChange={onReCaptchaChange} />
                            </div>

                            {/* Submit Button */}
                            <div className="col-12 text-center">
                                <button 
                                    type="submit" 
                                    className="submit-btn" 
                                    disabled={!verified}
                                >
                                    Place an Order
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
             <style jsx>{`
                .file-input-wrapper {
                position: relative;
                display: inline-block;
                }
                .file-input {
                opacity: 0;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                cursor: pointer;
                }
            `}</style>
        </>
    );
}

export default OrderForm;





// /* eslint-disable jsx-a11y/label-has-associated-control */
// import React, { useState } from 'react';
// import FormInput from './FormInput';
// import FormSelector from './FormSelector';
// import { ToastContainer, toast } from 'react-toastify';
// import { useHistory } from 'react-router-dom';
// import { PostApi } from '../../middleware/postMiddleware';
// import ReCAPTCHA from "react-google-recaptcha";
// import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// function OrderForm({ title, heading }) {
//     const history = useHistory();
//     const [cityId, setCity] = useState('');
//     const [verfied, setVerifed] = useState(false);
//     const [token, setToken] = useState(null);
//     const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);


//     //recaptcha function
//     function onChange(value) {
//         console.log("Captcha value:", value);
//         setVerifed(true);
//     }
//     const validateForm = (event) => {
//         const form = event.target;
//         const requiredFields = [
//             'contactPerson',
//             'title',
//             'city',
//             'state',
//             'zipcode',
//             'street',
//             'phone',
//             'ext',
//             'fax',
//             'email',
//             'website',
//             'style',
//         ];

//         for (const field of requiredFields) {
//             if (!form[field]?.value) {
//                 return false;
//             }
//         }
//         return true;
//     };

//     const onSubmitHandler = async (event) => {
//         event.preventDefault();

//         if (!validateForm(event)) {
//             toast.error('Please fill in all required fields.', {
//                 position: "top-center",
//                 autoClose: 3000,
//                 hideProgressBar: true,
//                 closeOnClick: true,
//                 pauseOnHover: false,
//                 draggable: false,
//                 progress: undefined,
//                 theme: "colored",
//             });
//             return;
//         }

//         const data = {
//             Fabrics_Swatch_Request__Company_Name: event.target?.companyName?.value,
//             Fabrics_Swatch_Request__Company_person: event.target?.contactPerson?.value,
//             Fabrics_Swatch_Request__Title: event.target?.title?.value,
//             Fabrics_Swatch_Request__Address: event.target?.street?.value,
//             Fabrics_Swatch_Request__City: event.target?.city?.value,
//             Fabrics_Swatch_Request__State: event.target?.state?.value,
//             Fabrics_Swatch_Request__Zip_Code: event.target?.zipcode?.value,
//             Fabrics_Swatch_Request__Country: event.target?.country?.value,
//             Fabrics_Swatch_Request__Tel: event.target?.phone?.value,
//             Fabrics_Swatch_Request__Fax: event.target?.fax?.value,
//             Fabrics_Swatch_Request__Email: event.target?.email?.value,
//             Fabrics_Swatch_Request__Web_Site: event.target?.website?.value,
//             Fabrics_Swatch_Request__Your_Experience: '',
//             Fabrics_Swatch_Request__Related_to: '',
//             Fabrics_Swatch_Request__Other: event.target?.other?.value,
//             Fabrics_Swatch_Request__Do_You_Have_Our_Current_Catalog: false,
//             Fabrics_Swatch_Request__Anything_in_specific: event.target?.specific?.value,
//             Fabrics_Swatch_Request__Product_style: event.target?.style?.value,
//         };

//         const res = await PostApi('testfabrics_fabrics_swatch_request', data);

//         if (res) {
//             toast.success('Response Sent Successfully', {
//                 position: "top-center",
//                 autoClose: 3000,
//                 hideProgressBar: true,
//                 closeOnClick: true,
//                 pauseOnHover: false,
//                 draggable: false,
//                 progress: undefined,
//                 theme: "colored",
//             });
//             setTimeout(() => {
//                 history.push('/');
//             }, 2500);
//         } else {
//             toast.error('Please Fill all the required data ', {
//                 position: "top-center",
//                 autoClose: 3000,
//                 hideProgressBar: true,
//                 closeOnClick: true,
//                 pauseOnHover: false,
//                 draggable: false,
//                 progress: undefined,
//                 theme: "colored",
//             });
//         }
//     };

//     return (
//         <>
//             <ToastContainer
//                 position="top-center"
//                 autoClose={3000}
//                 hideProgressBar
//                 newestOnTop={false}
//                 closeOnClick
//                 rtl={false}
//                 pauseOnFocusLoss={false}
//                 draggable={false}
//                 pauseOnHover={false}
//                 theme="colored"
//             />
//             <section className="contact-form-wrapper section-padding pt-0">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-12 text-left mb-20">
//                             <span>{title}</span>
//                             <h1>{heading}</h1>
//                         </div>
//                         <div className="col-12 col-lg-12 pb-4">
//                             <div className="contact-form">

//                                 <form onSubmit={onSubmitHandler} className="row conact-form">
//                                     <FormSelector
//                                         type="text"
//                                         labelFor="country"
//                                         label="* Select Your Country"
//                                         placeholder=""
//                                         id="country"
//                                         setCity={setCity}
//                                         cityId={cityId}
//                                         name="country"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="contactPerson"
//                                         label="* Contact Person"
//                                         placeholder="Enter Contact Person"
//                                         id="contactPerson"
//                                         name="contactPerson"
//                                         style={{marginLeft:"0"}}
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="title"
//                                         label="* Title"
//                                         placeholder="Enter Title"
//                                         id="title"
//                                         name="title"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="city"
//                                         label="* City"
//                                         placeholder="Enter City"
//                                         id="city"
//                                         name="city"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="state"
//                                         label="* State"
//                                         placeholder="Enter State"
//                                         id="state"
//                                         name="state"
//                                     />
//                                     <FormInput
//                                         type="number"
//                                         labelFor="zipcode"
//                                         label="* Zip Code:"
//                                         placeholder="Enter Zip Code"
//                                         id="zipcode"
//                                         name="zipcode"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="street"
//                                         label="* Street:"
//                                         placeholder="Enter Street"
//                                         id="street"
//                                         name="street"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="phone"
//                                         label="Phone (optional):"
//                                         placeholder="Enter Number"
//                                         id="phone"
//                                         name="phone"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="ext"
//                                         label="* Ext Applicable:"
//                                         placeholder="Enter Ext Applicable"
//                                         id="ext"
//                                         name="ext"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="fax"
//                                         label="* Fax:"
//                                         placeholder="Enter Fax"
//                                         id="fax"
//                                         name="fax"
//                                     />
//                                     <FormInput
//                                         type="email"
//                                         labelFor="email"
//                                         label="* Email"
//                                         placeholder="Enter Email"
//                                         id="email"
//                                         name="email"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="website"
//                                         label="* Web Site"
//                                         placeholder="Enter Website"
//                                         id="website"
//                                         name="website"
//                                     />

//                                     <FormInput
//                                         type="text"
//                                         labelFor="other"
//                                         label="* Other"
//                                         placeholder=""
//                                         id="other"
//                                         name="other"
//                                     />
//                                     {/*<div className="col-md-6 col-12">*/}
//                                     {/*    <label>Do you have current Catalog: </label>*/}
//                                     {/*    <input type="radio" id="currentCatalogYes" name="currentCatalog" value="yes" />*/}
//                                     {/*    <label htmlFor="currentCatalogYes">Yes</label>*/}
//                                     {/*    <input type="radio" id="currentCatalogNo" name="currentCatalog" value="no" />*/}
//                                     {/*    <label htmlFor="currentCatalogNo">No</label>*/}
//                                     {/*</div>*/}


//                                     <FormInput
//                                         type="text"
//                                         labelFor="specific"
//                                         label="* Anything In Specific: "
//                                         placeholder=""
//                                         id="specific"
//                                         name="specific"
//                                     />
//                                     <FormInput
//                                         type="text"
//                                         labelFor="style"
//                                         label="* Product Style#: "
//                                         placeholder=""
//                                         id="style"
//                                         name="style"
//                                     />
//                                     {/* <div className="col-md-6 col-6">
//                                         <label>Do you have current Catalog: </label>
//                                         <div>
//                                             <label htmlFor="currentCatalogYes" style={{width:"50%"}}>Yes</label>
//                                             <input type="radio" id="currentCatalogYes" name="currentCatalog" value="yes" style={{width:"50%"}} />
//                                             <label htmlFor="currentCatalogNo" style={{width:"50%"}}>No</label>
//                                             <input type="radio" id="currentCatalogNo" name="currentCatalog" value="no" style={{width:"50%"}} />
//                                         </div>
//                                     </div> */}
//                                     <div className="col-md-6 col-12">
//                                             <label >Chose Shipping Method: </label>
//                                             <div>
//                                                 <label htmlFor="html" style={{ width: "50%" }}>UPS</label>
//                                                 <input type="radio" id="html" name="shippingOrder" value="ups" style={{ width: "50%" }} />
//                                                 <label htmlFor="css" style={{ width: "50%" }}>Fedex</label>
//                                                 <input type="radio" id="css" name="shippingOrder" value="fesex" style={{ width: "50%" }} />
//                                                 <label htmlFor="javascript" style={{ width: "50%" }}>Other</label>
//                                                 <input type="radio" id="javascript" name="shippingOrder" value="other" style={{ width: "50%" }} />
//                                             </div>
//                                         </div>
//                                     <div className="col-md-6 col-6">
//                                         <label>Chose Payment Method: </label>
//                                         <div>
//                                         <label htmlFor="creditCard" style={{width:"50%"}}>Credit Card</label>
//                                         <input type="radio" id="creditCard" name="paymentOrder" value="credit card" style={{width:"50%"}}/>
//                                         <label htmlFor="cod" style={{width:"50%"}}>COD</label>
//                                         <input type="radio" id="cod" name="paymentOrder" value="cod" style={{width:"50%"}} />
//                                         <label htmlFor="purchaseOrder" style={{width:"50%"}}>Purchase Order</label>
//                                         <input type="radio" id="purchaseOrder" name="paymentOrder" value="Purchase Order" style={{width:"50%"}} />
//                                         </div>
//                                     </div>
//                                     <ReCAPTCHA

//                                         sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
//                                         onChange={onChange}
//                                     />
//                                     {/* <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
//                                         <GoogleReCaptcha
//                                             className="google-recaptcha-custom-class"
//                                             refreshReCaptcha={refreshReCaptcha}
//                                             onVerify={token => {
//                                                 setToken(token);
//                                             }}
//                                         />
//                                     </GoogleReCaptchaProvider> */}
//                                     <div className="col-md-12 col-12 text-center pt-2">
//                                         <input
//                                             className="submit-btn"
//                                             type="submit"
//                                             disabled={!verfied}
//                                             value="Send Request"
//                                             onSubmit={onSubmitHandler}
//                                         />
//                                     </div>
//                                 </form>

//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// }

// export default OrderForm;
